module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "posts"
    }
  }, [_c('div', {
    staticClass: "ui stackable grid"
  }, [_c('div', {
    staticClass: "equal width row primary"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post first",
    attrs: {
      "href": "https://blog.aragon.one/introducing-the-aragon-network-20b998e2caba",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            Introducing the Aragon Network\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 14")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post second",
    attrs: {
      "href": "https://blog.aragon.one/aragon-network-token-sale-terms-8998f63a3429",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            Aragon Network Token sale terms\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 21")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "equal width row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post third",
    attrs: {
      "href": "https://blog.aragon.one/announcing-the-aragon-network-token-sale-fe83fe36902c",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            Announcing the Aragon Network token sale\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 20")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post fourth",
    attrs: {
      "href": "https://blog.aragon.one/introducing-the-aragon-development-plan-857fbbe90779",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            Introducing the Aragon Development Plan\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 24")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "post fifth",
    attrs: {
      "href": "https://blog.aragon.one/the-path-to-mainstream-decentralized-organizations-d95a89d3cac4",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('h2', {
    staticClass: "ui inverted header"
  }, [_vm._v("\n            The path to mainstream decentralized organizations\n            "), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("Apr 25")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e716cef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posts.vue
// module id = 510
// module chunks = 1